import {
  Box,
  Checkbox,
  Flex,
  Input,
  Select,
  SimpleGrid,
} from "@chakra-ui/react";
import React from "react";
import { auditTexts } from "../../../../constants/auditTexts";
import type { AuditFilters as AuditFiltersType } from "../../../../types";

interface AuditFiltersProps {
  filters: AuditFiltersType;
  onFiltersChange: (filters: AuditFiltersType) => void;
}

const AuditFilters: React.FC<AuditFiltersProps> = ({
  filters,
  onFiltersChange,
}) => {
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    onFiltersChange({ ...filters, [name]: value, page: 1 });
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    onFiltersChange({ ...filters, [name]: checked, page: 1 });
  };

  return (
    <Box p={4} bg="gray.50" borderRadius="md">
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4}>
        <Input
          name="search"
          placeholder={auditTexts.filters.search}
          value={filters.search || ""}
          onChange={handleInputChange}
        />
        <Select
          name="table_name"
          value={filters.table_name || ""}
          onChange={handleInputChange}
        >
          <option value="">{auditTexts.filters.allTables}</option>
          <option value="properties">{auditTexts.tables.properties}</option>
          <option value="clients">{auditTexts.tables.clients}</option>
          <option value="profiles">{auditTexts.tables.profiles}</option>
          <option value="maintenance_fees">
            {auditTexts.tables.maintenance_fees}
          </option>
        </Select>
        <Select
          name="action"
          value={filters.action || ""}
          onChange={handleInputChange}
        >
          <option value="">{auditTexts.filters.allActions}</option>
          <option value="CREATE">{auditTexts.actions.CREATE}</option>
          <option value="UPDATE">{auditTexts.actions.UPDATE}</option>
          <option value="DELETE">{auditTexts.actions.DELETE}</option>
          <option value="RESTORE">{auditTexts.actions.RESTORE}</option>
        </Select>
        <Flex align="center">
          <Checkbox
            name="showDeleted"
            isChecked={filters.showDeleted}
            onChange={handleCheckboxChange}
          >
            {auditTexts.filters.showDeleted}
          </Checkbox>
        </Flex>
      </SimpleGrid>
    </Box>
  );
};

export default AuditFilters;
